import { render, staticRenderFns } from "./MySpaceSearch.vue?vue&type=template&id=744d5466&"
import script from "./MySpaceSearch.vue?vue&type=script&lang=js&"
export * from "./MySpaceSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports